import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "alert__image",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M4.5 22V17M4.5 7V2M2 4.5H7M2 19.5H7M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871\n        9.8428 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428\n        15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913\n        14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871\n        15.0162 8.24209 14.7342 7.50886L13 3Z",
    stroke: "#A334FF",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, null, -1);
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = {
    key: 1,
    class: "alert__image",
    width: "20",
    height: "20",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("path", {
    d: "M11 15.5V10M11 7H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z",
    stroke: "#6C90F4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, null, -1);
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
    key: 3,
    class: "alert__message"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(`alert alert__${_ctx.type}`)
    }, [
        (_ctx.type === 'secondary')
            ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
            : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6)),
        (_ctx.message)
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                class: "alert__message",
                ref: "messageRef",
                innerHTML: _ctx.message
            }, null, 8, _hoisted_7))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                _renderSlot(_ctx.$slots, "default")
            ]))
    ], 2));
}
